import Vue from 'vue';
import { MutationTree } from 'vuex';
import { PostgradTrialState } from './state';
import { PostgradTrial } from '@/models/postgradTrial/PostgradTrialModel';

const mutations: MutationTree<PostgradTrialState> = {
  SET_POSTGRAD_TRIAL_FOR_COURSE(
    state,
    payload: { descomplicaCourseId: string; trial: PostgradTrial },
  ) {
    const { descomplicaCourseId, trial } = payload;

    if (!descomplicaCourseId || !trial) return;

    Vue.set(state.trialByDescomplicaCourseId, descomplicaCourseId, trial);
  },
};

export default mutations;
